export default __webpack_public_path__ + "static/media/32.a279336e.jpg";